// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProducaoKpi_ServicosMensalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/producao_kpi/servicos_mensal.
 *
 * Returns one ProducaoKpi_ServicosMensalMesRow per month, ordered ascending,
 * covering the last 12-14 months.
 */
import type { ProducaoKpi_ServicosMensalMesRow } from './ProducaoKpi_ServicosMensalMesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProducaoKpi_ServicosMensalResponseDados {
meses: ProducaoKpi_ServicosMensalMesRow[]
}

export type ProducaoKpi_ServicosMensalResponse = ApiResponse<ProducaoKpi_ServicosMensalResponseDados>;

registerResponseContract('ProducaoKpi_ServicosMensalResponse', {
  meses: {
    type: 'array',
    required: true,
    items: {
      mes:        { type: 'string',  required: true },
      categorias: {
        type: 'array',
        required: false,
        items: {
          categoria: { type: 'string',  required: true },
          valor:     { type: 'number',  required: false },
        },
      },
      total_mes:  { type: 'number',  required: false },
    },
  },
})
